<template>
  <div>
    <SloTooltip
      :enabled="disabled"
      :text="'Subscription order is being processed and changes to this order can no longer be made.' | t"
    >
      <button
        :disabled="disabled"
        @click="modalOpen = true"
        class="flex-1 p-0 bg-transparent c-blue-400 text-left fw-book md:flex-auto hover:c-blue-700"
        type="button"
      >
        {{ 'Skip next shipment' | t }}
      </button>
    </SloTooltip>
    <transition name="fade-up">
      <SloModal v-if="modalOpen" :maxWidth="500" @dismiss="handleCloseModal">
        <template v-slot:title>
          {{ 'Need to skip your next order?' | t }}
        </template>
        <p>
          {{ 'If you skip your next order, your subscription will continue on it\'s normal frequency after that.' | t }}
        </p>
        <template v-slot:footer>
          <div class="grid grid-cols-1 gap-md w-100 sm:grid-cols-2">
            <SloButton
              @click="handleSkipNextShipment"
              :disabled="skipNextShipmentLoading"
              fill="outline"
              class="flex-1"
            >
              <SloLoader :loading="skipNextShipmentLoading" size="md">
               {{ 'Yes, skip order' | t }}
              </SloLoader>
            </SloButton>
            <SloButton @click="handleCloseModal" :disabled="skipNextShipmentLoading" class="flex">
              {{ 'No, keep my order' | t }}
            </SloButton>
          </div>
        </template>
      </SloModal>
    </transition>
  </div>
</template>

<script>
import t from '../../main/i18n';
import {marketplaceApi} from '../apis/marketplace';
import SloLoader from '../../../lib/components/SloLoader.vue';
import SloModal from '../../../lib/components/SloModal.vue';
import SloButton from '../../../lib/components/SloButton.vue';
import SloTooltip from '../../../lib/components/SloTooltip.vue';

export default {
  name: 'SubscriptionSkipNextShipment',
  components: {
    SloLoader,
    SloButton,
    SloModal,
    SloTooltip
  },
  filters: {
    t
  },
  props: {
    disabled: {type: Boolean, default: false},
    subscriptionId: {type: String|Number, required: true}
  },
  data() {
    return {
      modalOpen: false,
      skipNextShipmentLoading: false
    };
  },
  methods: {
    async handleSkipNextShipment() {
      this.skipNextShipmentLoading = true;

      await marketplaceApi.shipNextShipment(this.subscriptionId)
        .then(() => {
          this.handleCloseModal();
          this.$emit('subscriptionUpdated');
          this.$snotify.success(t('Next shipment skipped'));
        })
        .catch(() => {
          this.skipNextShipmentLoading = false;
          this.$snotify.error(t('Unable to skip next shipment'));
        });
    },
    handleCloseModal() {
      this.modalOpen = false;
      this.skipNextShipmentLoading = false;
    }
  }
};
</script>
